import React, { useContext, memo } from 'react'
import { CurrentUserContext } from '../../../context/Shared/CurrentUser.context'
import Avatar from '@mui/material/Avatar'
import { theme } from '../../../styles/theme.style'
import { getFirstName, getInitials } from '../../../utils/functions'
import { useTranslation } from 'react-i18next'
import { SideBarContext } from '../../../context/Shared/SideBar.context'
import { SelectPortal } from '../SelectPortal/SelectPortal.component'
import { AiFillCloseCircle } from 'react-icons/ai'

import styles from './SideBar.module.scss'

const TopSideBar = () => {
  const { me } = useContext(CurrentUserContext)
  const { isTabletOrMobile, setSideBarVisibility } = useContext(SideBarContext)
  const { t } = useTranslation()

  return (
    <>
      {isTabletOrMobile ? (
        <div className={styles.mobileHeader}>
          <div className={styles.mobileHeader__top}>
            <span className={styles.mobileHeader__welcome}>
              {t('Welcome')}, <strong>{getFirstName(me?.name || '')}</strong>
            </span>
            <button
              className={styles.closeButton}
              onClick={() => setSideBarVisibility(false)}
            >
              <AiFillCloseCircle className={styles.closeButton__icon} />
            </button>
          </div>
          <div className={styles.mobileHeader__portal}>
            <SelectPortal />
          </div>
        </div>
      ) : (
        <div className={styles.welcomeSection}>
          <Avatar
            sx={{
              width: 72,
              height: 72,
              bgcolor: theme.COLOR_LIGHT_BLUE,
              mb: 1,
              fontSize: 28
            }}
          >
            {getInitials(me?.name)}
          </Avatar>
          <div className={styles.welcomeTextRow}>
            <span className={styles.welcomeTextLabel}>{t('Welcome')}</span>
            <span className={styles.welcomeTextName}>{getFirstName(me?.name || '')}</span>
          </div>
        </div>
      )}
    </>
  )
}

export default memo(TopSideBar)
